import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

import { polyfill } from 'es6-promise';
polyfill();
import "./polyfills/object.dataset";
import "./polyfills/string.includes";
import "./polyfills/string.startsWith";
import "./polyfills/jquery.preBind";
import "./polyfills/arrayMethods";
import "./polyfills/objectMethods";
import "./polyfills/numberMethods";
import "./lib/wrapText";
import "./lib/fraction";
//import {getNonce} from "../../misc/utils";

import SqftFooter from "./components/sqftFooter";
import SqftIcons from "./components/SqftIcons";
import ChangeLayoutPopup from "../popups/changeLayoutPopup";
import SqftManualCalculateWindow from "./components/manualCalculate/SqftManualCalculateWindow";
import SqftNavSettingsWindow from "./components/popup/SqftNavSettingsWindow";
import SqftTutorial from "./components/popup/SqftTutorial";
// import SqftCabinetsTutorial from "./components/popup/SqftCabinetsTutorial";
import SqftSystemMessage from "./components/popup/SqftSystemMessage";
import AR3DPopup from "./components/popup/AR3DPopup";
import ValidationPopupWindow from "./components/popup/ValidationPopupWindow";
import SqftSystemDeleteMessage from "./components/popup/SqftSystemDeleteMessage";
import SqftLoadSlabWindow from "./components/slab/SqftLoadSlabWindow";
import SqftPopupWindow from "./components/popup/SqftPopupWindow";
import SqftLabelsContextMenuCategorySwitching
  from "./components/canvas/core/controls/labels/sqftLabelsContextMenuCategorySwitching";
import SqftLabelsContextMenu from "./components/canvas/core/controls/labels/sqftLabelsContextMenu";
import {
  setIsRoomSwitcherVisible,
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType
} from "../../actions/sqftMenuFunctions";
import SqftContextMenuV2 from "./components/popup/SqftContextMenuV2";
import ChangeValuePopupWindow from "./components/popup/ChangeValuePopupWindow";
import NavigationSidebar from "./components/navigation/NavigationSidebar";
import useUpdateSqftConfig from "./hocs/onLoad/useUpdateSqftConfig";
import useAddDeviceClass from "./hocs/onLoad/useAddDeviceClass";
//import useImportSQFTData from "./hocs/onLoad/useImportSQFTData";
import useToggleRoomsSwitcher from "./hocs/onLoad/useToggleRoomsSwitcher";
import useOpenSQFTMenu from "./hocs/onLoad/useOpenSQFTMenu";
import useCheckWizardActiveItem from "./hocs/onLoad/useCheckWizardActiveItem";
import useResetState from "./hocs/onLoad/useResetState";
import SqftHeader from "./components/header/SqftHeader";
import useUpdateCabinetFeatures from "./hocs/onLoad/useUpdateCabinetFeatures";
import SquareFootageToolViewWorkspace from "./squareFootageToolViewWorkspace";
//import NavigationSidebarRight from "./components/navigation/NavigationSidebarRight";
//import useSetDefaultCabinetViewMode from "./hocs/onLoad/useSetDefaultCabinetViewMode";

const SquareFootageToolView = (props) => {
  const {visualizersLoaded} = props;
  const {cartItems, sqftPopup, fabricatorSettings,
    setSQFTActiveRoomIndex, setSQFTActiveRoomType, setSQFTActiveRoomId, activeQuoteIndex,
    setIsRoomSwitcherVisible, contextMenuV2,  quotes, changeValuePopups, validationPopups, isSquareFootageEnabled} = props;

  useResetState();
  useUpdateSqftConfig();
  useAddDeviceClass();
  useToggleRoomsSwitcher( visualizersLoaded, fabricatorSettings, setIsRoomSwitcherVisible, quotes, setSQFTActiveRoomId,
    setSQFTActiveRoomIndex, setSQFTActiveRoomType, cartItems, activeQuoteIndex, isSquareFootageEnabled
  );
  //useSQFTRouting();
  //useSetDefaultCabinetViewMode(); //we assume is already in 2d
  useUpdateCabinetFeatures();

  useOpenSQFTMenu();
  useCheckWizardActiveItem();

  return (
    <div className="sqft">
      <div className="background-overlay">
        <div className="sqft-popup-wrapper-main">
          <SqftHeader/>
          <NavigationSidebar/>
          {/*<NavigationSidebarRight/>*/}
          <SquareFootageToolViewWorkspace />
        </div>
      </div>
      <SqftFooter/>
      <div className="popUp-overlay">
        {
          visualizersLoaded.length ? <SqftManualCalculateWindow/> : null
        }
        {
          visualizersLoaded.length ? <SqftLoadSlabWindow/> : null
        }
        {
          visualizersLoaded.length ? <AR3DPopup/> : null
        }
        <ChangeLayoutPopup/>
        <SqftSystemMessage/>
        <SqftPopupWindow {...sqftPopup}/>
        <SqftContextMenuV2 {...contextMenuV2}/>
        <SqftSystemDeleteMessage/>
        <SqftNavSettingsWindow/>
        {
          fabricatorSettings.useCategorySwitching ? <SqftLabelsContextMenuCategorySwitching/> : <SqftLabelsContextMenu/>
        }
        {
          changeValuePopups.map((changeValuePopup, index) => {
            return (
              <ChangeValuePopupWindow
                key={index}
                id={changeValuePopup.id}
                increaseCallback={changeValuePopup.increaseCallback}
                decreaseCallback={changeValuePopup.decreaseCallback}
                inputChangeCallback={changeValuePopup.inputChangeCallback}
                position={changeValuePopup.position}
                value={changeValuePopup.value}
                confirmCallback={changeValuePopup.confirmCallback}
              />
            )
          })
        }
        {
          validationPopups.map((validationPopup, index) => {
            return (
              <ValidationPopupWindow
                key={index}
                id={validationPopup.id}
                text={validationPopup.text}
                position={validationPopup.position}
              />
            )
          })
        }
        <SqftTutorial/>
        {/*<SqftCabinetsTutorial/>*/}
      </div>
      <div className="hidden-overlay">
        <SqftIcons/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {sqftFeaturesPopup} = store.sqftState;

  return {
    quotes: store.quotesState.quotes,
    fabricatorData: store.fabricatorState,
    sqftVisited: sqftFeaturesPopup.visited,
    sqftPopup: store.sqftMenuState.sqftPopup,
    activeButton: store.sqftMenuState.activeButton,
    contextMenuV2: store.sqftMenuState.contextMenuV2,
    isMobile: store.serverState.isMobile,
    cartItems: store.cartState.cartItems,
    windowWidth: store.serverState.windowWidth,
    visualizersLoaded: store.serverState.visualizersLoaded,
    isShowSlabTool: store.sqftSlabState.isShowSlabTool,
    fabricatorSettings: store.fabricatorState.settings,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    changeValuePopups: store.sqftMenuState.changeValuePopups,
    validationPopups: store.sqftMenuState.validationPopups,
    isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
  };
};

const mapDispatchToProps = {
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType,
  setIsRoomSwitcherVisible,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolView)
);
